import avif640 from "@/assets/hero/hero-family-home-640.avif";
import avif1024 from "@/assets/hero/hero-family-home-1024.avif";
import avif1600 from "@/assets/hero/hero-family-home-1600.avif";
import avif1920 from "@/assets/hero/hero-family-home-1920.avif";
import webp640 from "@/assets/hero/hero-family-home-640.webp";
import webp1024 from "@/assets/hero/hero-family-home-1024.webp";
import webp1600 from "@/assets/hero/hero-family-home-1600.webp";
import webp1920 from "@/assets/hero/hero-family-home-1920.webp";
import { cn } from "@/lib/utils";

/**
 * Hero-bakgrunden som riktig bild (AVIF/WebP i flera storlekar) i stället för
 * CSS-bakgrund, så att webbläsaren hittar den direkt i HTML:en och väljer rätt
 * storlek för skärmen. Ligger absolut bakom innehållet, som den gamla bakgrunden.
 */
const HeroBackgroundImage = ({ className }: { className?: string }) => (
  <picture>
    <source
      type="image/avif"
      srcSet={`${avif640} 640w, ${avif1024} 1024w, ${avif1600} 1600w, ${avif1920} 1920w`}
      sizes="100vw"
    />
    <source
      type="image/webp"
      srcSet={`${webp640} 640w, ${webp1024} 1024w, ${webp1600} 1600w, ${webp1920} 1920w`}
      sizes="100vw"
    />
    <img
      src={webp1600}
      alt=""
      aria-hidden="true"
      width={1920}
      height={1080}
      fetchPriority="high"
      decoding="async"
      className={cn("absolute inset-0 h-full w-full object-cover object-center", className)}
    />
  </picture>
);

export default HeroBackgroundImage;
